// src/components/ClientsSection.jsx
import React from "react";
import "./TrajectorySection.css";

const TopClientsSection = () => {
    return (
        <section className="white-section">
        <div className="proyectos-container">
          <div className="proyecto-hero">
            <div className="proyecto-texto">
              <h3 className="proyecto-subtitulo">Descubre más sobre nuestra trayectoria</h3>
              <p className="proyecto-descripcion">En CNgroup transformamos la energía renovable en soluciones tangibles desde nuestra fundación. Conoce un poco más quiénes somos y lo que hacemos.</p>
            </div>

            <div className="proyectos-cards-container">
              <div className="proyecto-card">
                <div className="proyecto-numero">20</div>
                <h4 className="proyecto-titulo">Años de experiencia</h4>
              </div>

              <div className="proyecto-card">
                <div className="proyecto-numero">27</div>
                <h4 className="proyecto-titulo">Proyectos completados</h4>
              </div>

              <div className="proyecto-card">
                <div className="proyecto-numero">46</div>
                <h4 className="proyecto-titulo">Proyectos en desarrollo</h4>
              </div>

              <div className="proyecto-card">
                <div className="proyecto-numero">47</div>
                <h4 className="proyecto-titulo">Trabajadores en plantilla</h4>
              </div>

              <div className="proyecto-card">
                <div className="proyecto-numero">3</div>
                <h4 className="proyecto-titulo">Continentes</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

        
    );
};

export default TopClientsSection;